const quizQuestions = document.querySelectorAll('[data-quiz-question]')

if (quizQuestions) {
  const incorrectResponse = {
    label: gettext('Incorrect'),
    text: () => {
      const responses = [
        gettext('Try again!'),
        gettext('Oops! Wrong answer'),
      ]
      return responses[parseInt(responses.length * Math.random())]
    },
    icon: '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="80" height="80" aria-hidden="true"><rect width="256" height="256" fill="none"/><line x1="160" y1="96" x2="96" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><line x1="96" y1="96" x2="160" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  }
  const correctResponse = {
    label: gettext('Correct'),
    text: () => {
      const responses = [
        gettext('Correct!'),
        gettext('That’s right!'),
        gettext('Good job!'),
      ]
      return responses[parseInt(responses.length * Math.random())]
    },
    icon: '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="80" height="80" aria-hidden="true"><rect width="256" height="256" fill="none"/><polyline points="88 136 112 160 168 104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>',

  }

  for (const questionEl of quizQuestions) {
    const questionNumber = questionEl.getAttribute('data-quiz-question')
    const optionsList = questionEl.querySelector(`#q${questionNumber}-options`)
    const options = questionEl.querySelectorAll('[data-option]')
    const feedbackEl = questionEl.querySelector(`#q${questionNumber}-feedback`)

    feedbackEl.setAttribute('aria-live', 'polite')
    feedbackEl.setAttribute('aria-atomic', 'true')

    questionEl.addEventListener('click', (event) => {
      for (const opt of options) {
        opt.removeAttribute('aria-describedby')
      }

      if (event.target.getAttribute('data-option')) {
        let isCorrect = event.target.getAttribute('data-option') === '1'
        questionEl.setAttribute('data-quiz-question-state', (isCorrect ? 'correct' : ''))
        optionsList.setAttribute('aria-label', isCorrect ? correctResponse.label : incorrectResponse.label)
        event.target.setAttribute('aria-describedby', `q${questionNumber}-options`)

        feedbackEl.innerHTML = `
          <p class="quiz-feedback-title">
            ${ isCorrect ? correctResponse.icon : incorrectResponse.icon }
            ${ isCorrect ? correctResponse.text() : incorrectResponse.text() }
          </p>
          ${ (isCorrect && feedbackEl.dataset.feedbackText) ? '<p>' + feedbackEl.dataset.feedbackText + '</p>' : '' }
        `
      }
    })
  }
}
